export const API_URL =
  "https://hhtd-proxy-512456290675.asia-east1.run.app/api/v1";
